import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { firstValueFrom, race, timer } from 'rxjs'
import { filter, map, take } from 'rxjs/operators'
import { LocalUserService } from '@app/common/services/local-user.service'
import { AccessRole } from '@app/user-management/types/access-role'
import { User } from '@app/user-management/types/user'

export const speechyAdminGuard: CanActivateFn = async () => {
  const localUserService = inject(LocalUserService)
  const router = inject(Router)

  // Fast path: user is already loaded in storage on app boot.
  if (localUserService.isSpeechyAdmin()) {
    return true
  }

  // Slow path: deep-link/refresh - activeUserSignal is still `undefined` because
  // it's `requireSync` over a BehaviorSubject seeded with undefined. Mirror
  // RedirectionComponent's pattern and race the user emission against 10s.
  const user = await firstValueFrom(
    race(
      localUserService.activeUser$.pipe(
        filter((u): u is User => !!u),
        take(1)
      ),
      timer(10000).pipe(map(() => null as User | null))
    )
  )

  if (user?.accessRole === AccessRole.SPEECHY_ADMIN) {
    return true
  }

  return router.createUrlTree(['/403'])
}
